import React, { useState, useRef, useEffect } from 'react';
import { FiSearch, FiBell, FiUser, FiHome, FiChevronDown, FiLogOut, FiUser as FiUserIcon } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import './Header.scss';

const decodeTokenPayload = (token) => {
    try {
        const payload = token?.split('.')[1];
        if (!payload) return {};
        const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
        const decoded = decodeURIComponent(
            window.atob(normalized)
                .split('')
                .map(char => `%${char.charCodeAt(0).toString(16).padStart(2, '0')}`)
                .join('')
        );
        return JSON.parse(decoded);
    } catch {
        return {};
    }
};

const getStoredAdminProfile = () => {
    let storedUser = {};
    try {
        storedUser = JSON.parse(localStorage.getItem('adminUser') || '{}');
    } catch {
        storedUser = {};
    }

    const tokenUser = decodeTokenPayload(localStorage.getItem('accessToken'));
    const role = storedUser?.Roles?.Name
        || storedUser?.roles?.name
        || storedUser?.role
        || tokenUser?.role
        || 'User';

    return {
        name: storedUser?.FullName
            || storedUser?.fullName
            || storedUser?.Username
            || storedUser?.username
            || tokenUser?.username
            || 'User',
        role,
    };
};

const Header = ({ moduleName }) => {
    const navigate = useNavigate();
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const [profile] = useState(getStoredAdminProfile);
    const menuRef = useRef(null);

    const toggleProfileMenu = () => setShowProfileMenu(prev => !prev);

    const handleLogout = () => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('adminUser');
        navigate('/admin/auth/login', { replace: true });
    };

    // Đóng dropdown khi click ra ngoài
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setShowProfileMenu(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <header className="admin-header">
            <div className="breadcrumb">
                <FiHome className="home-icon" />
                <span className="dashboard">Admin</span>
                <span className="separator">/</span>
                <span className="current">{moduleName}</span>
            </div>
            <div className="header-actions">
                <div className="search-wrapper">
                    <FiSearch className="search-icon" />
                    <input type="text" placeholder="Search anything..." />
                </div>
                <div className="notification-btn-wrapper">
                    <button className="icon-btn" aria-label="Notifications">
                        <FiBell />
                        <span className="notification-badge"></span>
                    </button>
                </div>
                <div className="profile-wrapper" ref={menuRef} onClick={toggleProfileMenu}>
                    <div className="avatar">
                        <FiUser />
                    </div>
                    <div className="profile-info">
                        <span className="profile-name" title={profile.name}>{profile.name}</span>
                        <span className="profile-role" title={profile.role}>{profile.role}</span>
                    </div>
                    <FiChevronDown className={`dropdown-arrow ${showProfileMenu ? 'rotate' : ''}`} />

                    {/* Dropdown menu */}
                    {showProfileMenu && (
                        <div className="profile-dropdown">
                            <div className="dropdown-item" onClick={() => navigate('/admin/profile')}>
                                <FiUserIcon />
                                <span>My Profile</span>
                            </div>
                            <div className="dropdown-divider" />
                            <div className="dropdown-item logout" onClick={handleLogout}>
                                <FiLogOut />
                                <span>Logout</span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
};

export default Header;
